<template>
    <div>
        <Wp_nav_bar title="活跃值"></Wp_nav_bar>
        <div style="box-shadow: 1px 1px 5px #999999">
            <van-cell size="large" title="总活跃值" :value="all_active_value">
            </van-cell>
            <van-cell size="large" title="推广活跃值" :value="tuiguang_active_value">
            </van-cell>
            <van-cell size="large" title="推荐活跃值" :value="tuijian_active_value">
            </van-cell>
        </div>
        <div style="padding: 15px">
            <div style="border-radius: 5px; box-shadow: 1px 1px 5px #999999; color: #EE0A24; font-size: 15px; padding: 15px">
                注：每天早上5点左右更新截止昨天的近30日活跃值，每日更新一次
            </div>
<!--            <div v-if="role_id === '0'" style="border-radius: 5px; box-shadow: 1px 1px 5px #999999; color: #EE0A24; font-size: 15px; padding: 15px; margin-top: 15px">-->
<!--                <div style="font-size: 17px; color: #222222; margin-bottom: 5px">春风计划——活跃值冲击赛</div>-->
<!--                <div style="color: #555555">-->
<!--                    <van-row style="padding: 5px 0px; border-bottom: 1px dashed #cccccc">-->
<!--                        <van-col span="18"  style="padding-top: 5px">-->
<!--                            推广活跃值≥100&nbsp;&nbsp;&nbsp;&nbsp;奖励10元-->
<!--                        </van-col>-->
<!--                        <van-col span="6" style="text-align: center">-->
<!--                            <van-button :disabled="level_1_disable"-->
<!--                                        :type="level_1_type"-->
<!--                                        :color="level_1_color"-->
<!--                                        size="small"-->
<!--                                        style="width: 100%"-->
<!--                                        @click="submitToGetAward(1)"-->
<!--                            >{{level_1_name}}</van-button>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                    <van-row style="padding: 5px 0px; border-bottom: 1px dashed #cccccc">-->
<!--                        <van-col span="18" style="padding-top: 5px">-->
<!--                            推广活跃值≥300&nbsp;&nbsp;&nbsp;&nbsp;奖励40元-->
<!--                        </van-col>-->
<!--                        <van-col span="6" style="text-align: center">-->
<!--                            <van-button :disabled="level_2_disable"-->
<!--                                        :type="level_2_type"-->
<!--                                        :color="level_2_color"-->
<!--                                        size="small"-->
<!--                                        style="width: 100%" @click="submitToGetAward(2)"-->
<!--                            >{{level_2_name}}</van-button>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                    <van-row style="padding: 5px 0px; border-bottom: 1px dashed #cccccc">-->
<!--                        <van-col span="18"  style="padding-top: 5px">-->
<!--                            推广活跃值≥500&nbsp;&nbsp;&nbsp;&nbsp;奖励50元-->
<!--                        </van-col>-->
<!--                        <van-col span="6" style="text-align: left">-->
<!--                            <van-button :disabled="level_3_disable"-->
<!--                                        :type="level_3_type"-->
<!--                                        :color="level_3_color"-->
<!--                                        size="small"-->
<!--                                        style="width: 100%"-->
<!--                                        @click="submitToGetAward(3)"-->
<!--                            >{{level_3_name}}</van-button>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                </div>-->
<!--                <div style="margin-top: 10px; color: orange">-->
<!--                    温馨提示：点击领取后，京东小妹将再3个工作日内与您联系并发放奖励，请注意微信好友申请-->
<!--                </div>-->
<!--            </div>-->
            <div style="border-radius: 5px; box-shadow: 1px 1px 5px #999999; color: #555555; font-size: 15px; padding: 15px; margin-top: 15px">
                <h3>【活跃值规则说明】</h3><br/>
                <div v-html="active_value_explain.replace(new RegExp('\n','g'), '<br/>')">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import {Toast} from "vant";

    export default {
        name: "Wp_mini_member_active_value_detail",
        components: {Wp_nav_bar},
        data(){
            return{
                all_active_value: '0',
                tuiguang_active_value: '0',
                tuijian_active_value: '0',
                active_value_explain: '1.活跃值说明：\n' +
                    '① 活跃值可在万品京选小程序的会员界面查看；\n' +
                    '② 活跃值由近30天自己推广和直属超级会员推广佣金产生，累计不满1元的部分不计入；\n' +
                    '③ 推广活跃值：自己推广佣金1元=1分，1000分封顶；\n' +
                    '    推荐活跃值：直属超级会员推广佣金1元=1分，1000分封顶，累计不满1元的部分不计入；\n' +
                    '④ 6月18日、11月11日、12月12日当天的推广佣金4元=1分；\n'
                    // + '⑤ 完成订单状态才会计入活跃值（确认收货后订单变为完成订单状态）'

                    // + '\n\n2.活跃超级会员说明：（以下2个条件任选其一）\n' +
                    // '① 配置智能发品助理且近30天推广收益大于20元的超级会员\n' +
                    // '② 活跃值大于200的超级会员'
                ,

                //会员级别
                role_id: '',

                level_1_name: '未达标',
                level_1_disable: true,
                level_1_type: '',
                level_1_color: '#999999',
                level_2_name: '未达标',
                level_2_disable: true,
                level_2_type: '',
                level_2_color: '#999999',
                level_3_name: '未达标',
                level_3_disable: true,
                level_3_type: '',
                level_3_color: '#999999',

                active_status_points: 0,
            }
        },

        created() {
            this.initActiveValues();
            this.getUserActiveStatus();
        },

        methods: {
            initActiveValues(){
                if(this.$route.query){
                    this.all_active_value = this.$route.query.all_value;
                    this.tuiguang_active_value = this.$route.query.tuiguang_value;
                    this.tuijian_active_value = this.$route.query.tuijian_value;
                    this.role_id = this.$route.query.role_id;
                }
            },

            /**
             * 获取活动中奖励信息的状态数据
             */
            getUserActiveStatus(){
                let params = {
                    uid: this.$store.state.username
                };
                this.$getUserActiveStatus(params, response=>{
                    // response = {"code":200,"u_mark":"S101","leve1":"true","leve3":"false","leve2":"false","points":"350"};
                    if(response && response.code === 200){
                        if(response.points){
                            this.active_status_points = Number(response.points);
                        }
                        if(response.leve1){
                            if(response.leve1 === 'false'){//false状态表示未提款
                                if(this.active_status_points >= 100){
                                    this.level_1_disable = false;
                                    this.level_1_name = '领取';
                                }else{
                                    this.level_1_disable = true;
                                    this.level_1_name = '未达标';
                                }
                            }else{
                                this.level_1_disable = true;
                                this.level_1_name = '已领取';
                            }

                            if(this.level_1_name === '未达标'){
                                this.level_1_type = '';
                                this.level_1_color = '#999999';
                            }else if(this.level_1_name === '已领取'){
                                this.level_1_type = 'info';
                                this.level_1_color = '';
                            }else{
                                this.level_1_type = 'primary';
                                this.level_1_color = '';
                            }
                        }

                        if(response.leve2){
                            if(response.leve2 === 'false'){//false状态表示未提款
                                if(this.active_status_points >= 300){
                                    this.level_2_disable = false;
                                    this.level_2_name = '领取';
                                }else{
                                    this.level_2_disable = true;
                                    this.level_2_name = '未达标';
                                }
                            }else{
                                this.level_2_disable = true;
                                this.level_2_name = '已领取';
                            }

                            if(this.level_2_name === '未达标'){
                                this.level_2_type = '';
                                this.level_2_color = '#999999';
                            }else if(this.level_2_name === '已领取'){
                                this.level_2_type = 'info';
                                this.level_2_color = '';
                            }else{
                                this.level_2_type = 'primary';
                                this.level_2_color = '';
                            }
                        }

                        if(response.leve3){
                            if(response.leve3 === 'false'){//false状态表示未提款
                                if(this.active_status_points >= 500){
                                    this.level_3_disable = false;
                                    this.level_3_name = '领取';
                                }else{
                                    this.level_3_disable = true;
                                    this.level_3_name = '未达标';
                                }
                            }else{
                                this.level_3_disable = true;
                                this.level_3_name = '已领取';
                            }

                            if(this.level_3_name === '未达标'){
                                this.level_3_type = '';
                                this.level_3_color = '#999999';
                            }else if(this.level_3_name === '已领取'){
                                this.level_3_type = 'info';
                                this.level_3_color = '';
                            }else{
                                this.level_3_type = 'primary';
                                this.level_3_color = '';
                            }
                        }
                    }
                })
            },

            submitToGetAward(_type){
                let params = {
                    uid: this.$store.state.username,
                    points: this.active_status_points,
                    type: _type
                };
                this.$submitToGetAward(params, response=>{
                    if(response){
                        if(response.code === 200){
                            Toast.success({
                                message: '提交成功'
                            })
                        }else{
                            Toast.fail({
                                message: '已提交\n请勿重复提交'
                            })
                        }
                    }else{
                        Toast.fail({
                            message: '数据提交失败\n请稍后再试'
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>